/**
 * Artist page DISCOGRAPHY / VIDEOS sliders (.art-slider) + PERFORMANCE (.history-section .history-slider)
 */
export class ArtSlider {
  private swipers: unknown[] = [];

  init(): void {
    if (typeof (window as Window & { Swiper?: unknown }).Swiper === 'undefined') return;

    const SwiperClass = (window as Window & { Swiper: new (el: Element, o: object) => unknown }).Swiper;

    // DISCOGRAPHY / VIDEOS
    const blocks = document.querySelectorAll<HTMLElement>('.sub-artist-view .art-slider');
    blocks.forEach((block) => {
      const wrapper = block.querySelector('.swiper-wrapper');
      if (!wrapper) return;

      const nextEl = block.querySelector<HTMLElement>('.swiper-button-next');
      const prevEl = block.querySelector<HTMLElement>('.swiper-button-prev');

      const swiper = new SwiperClass(block, {
        speed: 400,
        slidesPerView: 1,
        spaceBetween: 24,
        navigation: nextEl && prevEl ? { nextEl, prevEl } : undefined,
        breakpoints: {
          0: { slidesPerView: 1, spaceBetween: 16 },
          544: { slidesPerView: 2, spaceBetween: 24 },
          768: { slidesPerView: 3, spaceBetween: 24 },
          1200: { slidesPerView: 4, spaceBetween: 32 },
        },
      });
      this.swipers.push(swiper);
    });

    // PERFORMANCE (history-section): 기본 4개씩
    const historySection = document.querySelector<HTMLElement>('.sub-artist-view .history-section');
    if (historySection) {
      const sliderEl = historySection.querySelector<HTMLElement>('.history-slider');
      const nextEl = historySection.querySelector<HTMLElement>('.f-wrap .swiper-button-next');
      const prevEl = historySection.querySelector<HTMLElement>('.f-wrap .swiper-button-prev');
      if (sliderEl && sliderEl.querySelector('.swiper-wrapper')) {
        const swiper = new SwiperClass(sliderEl, {
          speed: 400,
          slidesPerView: 1,
          spaceBetween: 24,
          navigation: nextEl && prevEl ? { nextEl, prevEl } : undefined,
          breakpoints: {
            544: { slidesPerView: 2, spaceBetween: 24 },
            768: { slidesPerView: 3, spaceBetween: 24 },
            1200: { slidesPerView: 4, spaceBetween: 32 },
          },
        });
        this.swipers.push(swiper);
      }
    }
  }
}
